module.exports = __webpack_public_path__ + "static/img/1_0021.db26a07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0021.jpg
// module id = X8pI
// module chunks = 0